/** Renders an instant in the reader's own zone, naming the zone so ordering is unambiguous. */
export const formatInstant = (iso: string | null | undefined): string => {
  if (!iso) return "—";

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);

  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });
};

/** Seconds between two instants, or null when either is missing or unparseable. */
export const secondsBetween = (
  earlier: string | null | undefined,
  later: string | null | undefined,
): number | null => {
  if (!earlier || !later) return null;

  const from = new Date(earlier).getTime();
  const to = new Date(later).getTime();
  if (Number.isNaN(from) || Number.isNaN(to)) return null;

  return Math.round((to - from) / 1000);
};
